import { Component, OnInit } from '@angular/core';
import { Constantes } from '../../../environments/constants';
import { ApiService } from '../../../../src/app/servicios/api.service';
import { Router } from '@angular/router'
@Component({
  selector: 'app-app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss']
})
export class AppFooterComponent implements OnInit {

  public CONSTANTES = Constantes;
  public enlaces:any [];
  constructor(private _api: ApiService, private _router: Router) { }

  ngOnInit() {
    $('.sroll_top').on('click', function () {
      $('html, body').animate({
        scrollTop: 0
      }, 3000);
      return false;
    });
    this.obtenerEnlaces();

  }

  private obtenerEnlaces() {
    this._api.get('enlaces').subscribe((enlacesResponse: Response) => {
      this.enlaces = this._api.reader.read(enlacesResponse, []);
    })
  }

  public verEnlace(e) {
    switch (e.tipo) {
      case 1:
        window.open(e.contenido, '_blank');
        break;
      case 2:
        this._router.navigate([e.contenido]);
        break;
      case 3:
        this._router.navigate(['/pagina', e.contenido]);
        break;
      default:
        console.error('Se trató de acceder a un enlace inválido: ', e);
        break;
    }
  }

}
